"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var carCarbonModel = _interopRequireWildcard(require("./car/index"));

var electricityWorldAverageCarbonModel = _interopRequireWildcard(require("./electricity/worldaverage"));

var energyCarbonModel = _interopRequireWildcard(require("./energy/index"));

var flightCarbonModel = _interopRequireWildcard(require("./flights/index"));

var ingredientsCarbonModel = _interopRequireWildcard(require("./food/ingredients"));

var mealCarbonModel = _interopRequireWildcard(require("./food/meal"));

var hotelCarbonModel = _interopRequireWildcard(require("./hotelpercountry/index"));

var purchaseCarbonModel = _interopRequireWildcard(require("./purchase/index"));

var transportationCarbonModel = _interopRequireWildcard(require("./transportation/index"));

// Note: fallback models must be at the end
var carbonModels = [ingredientsCarbonModel, mealCarbonModel, carCarbonModel, flightCarbonModel, transportationCarbonModel, energyCarbonModel, hotelCarbonModel, purchaseCarbonModel, electricityWorldAverageCarbonModel];
var _default = carbonModels;
exports["default"] = _default;